var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"dense":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }